import React, { Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import { Loader } from "atoms";

import Login from "Pages/Auth/Login";

import AuthLayout from "Layout/AuthLayout";
import DashboardLayout from "Layout/DashboardLayout";
import Test from "Pages/Test";
import { Dashboard } from "Pages/Dashboard";
import { PropertyListing } from "Pages/PropertyListing";
import { Master } from "Pages/Master";
import { Setting } from "Pages/Setting";
import Otp from "Pages/Auth/Otp";
import ResetPassword from "Pages/Auth/ResetPassword";
import ResetSuccess from "Pages/Auth/ResetSuccess";
import SendEmail from "Pages/Auth/SendEmail";
import { Logout } from "Pages/Auth/Logout";
import { PropsochProvider } from "contexts/Propsoch";
import UserActivity from "Pages/Setting/UserActivity";
import Properties from "Pages/PropertyListing/Properties";

export const UnauthenticatedRoutes = React.memo(() => {
  return (
    <AuthLayout>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="login" element={<Login />} />
          <Route path="otp" element={<Otp />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="reset-success" element={<ResetSuccess />} />
          <Route path="send-email" element={<SendEmail />} />
          <Route path="test" element={<Test />} />
          <Route path="*" element={<Navigate to="login" />} />
        </Routes>
      </Suspense>
    </AuthLayout>
  );
});

export const AuthenticatedRoutes = React.memo(() => {
  return (
    <PropsochProvider>
      <DashboardLayout>
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="test" element={<Test />} />
            <Route path="logout" element={<Logout />} />
            {/* <Route path="property-listing" element={<Properties />} /> */}
            <Route path="property-listing">
              <Route index element={<Properties />} />
              <Route path="add" element={<PropertyListing />} />
              <Route path="add/:id" element={<PropertyListing />} />
            </Route>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="master/:id" element={<Master />} />
            <Route path="setting/:id" element={<Setting />} />
            <Route path="setting/:id/:userId" element={<UserActivity />} />
            <Route path="*" element={<Navigate to="dashboard" />} />
          </Routes>
        </Suspense>
      </DashboardLayout>
    </PropsochProvider>
  );
});
